/* eslint-disable react-hooks/exhaustive-deps */
import { ICardWidget, IComponentWidget, IContentPicker, IContentType, IFileWidget, IImageGalleryWidget, IItineraryWidget, IMapWidget, IParagraphWidget, ISlideshowWidget, IVideoWidget, WidgetType } from "@common/models/CMS";
import { IViewport } from "@config/appConfig";
import Config from "@service/Config";
import { apolloQuery } from "@service/graphql";
import { GET_BANNER_WIDGET, GET_CARD_WIDGET, GET_COMPONENT_WIDGET, GET_FILE_WIDGET, GET_IMAGE_GALLERY_WIDGET, GET_ITINERARY_WIDGET, GET_MAP_WIDGET, GET_PARAGRAPH_WIDGET, GET_SLIDESHOW_WIDGET, GET_VIDEO_WIDGET } from "@service/graphql/query/Query.Bag";
import { FC, useEffect, useState } from "react";
import CardWidget from "./CardWidget";
import ComponentWidget from "./ComponentWidget";
import FileWidget from "./FileWidget";
import ImageGalleryWidget from "./ImageGalleryWidget";
import ItineraryWidget from "./ItineraryWidget";
import { MapWidget } from "./mapWidget/index";
import ParagraphWidget from "./ParagraphWidget";
import { SlideShowWidget } from "./slideShowWidget/index";
import VideoWidget from "./VideoWidget";
import WidgetArea from "./WidgetArea";
import { store } from "@misc/Reducer";
import { CustomizationType, ICustomization, ScreenSize, ILayoutStyle } from "@common/models/CMS/index";
import BannerWidget from "./BannerWidget";
import { IGeneralContainer } from "@common/models/CMS/GeneralContainer";
import { camelize } from "@utilize/Util";


interface IWidgetContainer {
    generalContainer?: IGeneralContainer
}

const WidgetContainer: FC<IWidgetContainer> = ({ generalContainer }) => {
    const [widgets, setWidgets] = useState<Array<IVideoWidget | IImageGalleryWidget | IMapWidget | ISlideshowWidget | IParagraphWidget | IFileWidget | ICardWidget | IItineraryWidget | IComponentWidget | undefined>>([]);
    const name = camelize(generalContainer?.__typename || "");
    useEffect(() => {
        generalContainer?.content?.contentItems.forEach((contentItem, index) => {
            const query = selectWidgetQuery(contentItem.contentType || '');
            apolloQuery(query, { query, variables: { contentItemId: generalContainer.contentItemId } })
                .then((response) => {
                    widgets[index] = response.data[name].length ? response.data[name][0].content?.contentItems.find((p: IContentType) => p.contentItemId === contentItem.contentItemId) : undefined;
                    setWidgets(widgets.slice());
                })
        })
    }, [generalContainer?.content]);

    const selectWidgetQuery = (contentType: string) => {
        switch (contentType) {
            case 'ParagraphWidget':
                return GET_PARAGRAPH_WIDGET(name);
            case 'VideoWidget':
                return GET_VIDEO_WIDGET(name);
            case 'FileWidget':
                return GET_FILE_WIDGET(name);
            case 'ImageGalleryWidget':
                return GET_IMAGE_GALLERY_WIDGET(name);
            case 'ItineraryWidget':
                return GET_ITINERARY_WIDGET(name);
            case 'SlideshowWidget':
                return GET_SLIDESHOW_WIDGET(name);
            case 'MapWidget':
                return GET_MAP_WIDGET(name);
            case 'CardWidget':
                return GET_CARD_WIDGET(name);
            case 'ComponentWidget':
                return GET_COMPONENT_WIDGET(name);
            case 'BannerWidget':
                return GET_BANNER_WIDGET(name);
            default:
                return GET_PARAGRAPH_WIDGET(name);
        }
    }

    const renderContent = (widget: any) => {
        switch (widget.contentType) {
            case WidgetType[WidgetType.ParagraphWidget]:
                return <ParagraphWidget dataSource={widget} />;
            case WidgetType[WidgetType.ImageGalleryWidget]:
                return <ImageGalleryWidget dataSource={widget} />;
            case WidgetType[WidgetType.SlideshowWidget]:
                return <SlideShowWidget dataSource={widget} />;
            case WidgetType[WidgetType.VideoWidget]:
                return <VideoWidget dataSource={widget} />;
            case WidgetType[WidgetType.FileWidget]:
                return <FileWidget dataSource={widget} />;
            case WidgetType[WidgetType.MapWidget]:
                return <MapWidget dataSource={widget} />;
            case WidgetType[WidgetType.ItineraryWidget]:
                return <ItineraryWidget dataSource={widget} />;
            case WidgetType[WidgetType.CardWidget]:
                return <CardWidget dataSource={widget} />;
            case WidgetType[WidgetType.ComponentWidget]:
                return <ComponentWidget dataSource={widget} />;
            case WidgetType[WidgetType.BannerWidget]:
                return <BannerWidget dataSource={widget} />;
            default:
                return "";
        }
    }

    return (
        <main className="widget-container">
            {widgets.map((widget, index) => {
                if (widget)
                    return (
                        <WidgetArea key={index} dataSource={widget}>
                            {renderContent(widget)}
                        </WidgetArea>
                    )
                else
                    return '';
            })}
        </main>
    )
}

export function getCurrentScreenSize() {
    const width: number = store.getState().windowWidth;
    const { small, medium, large } = Config.get<IViewport>("viewport");
    let currentScreenSize: ScreenSize =
        width > large ? "xlarge" :
            width > medium && width <= large ? "large" :
                width > small && width <= medium ? "medium" : "small";
    return currentScreenSize
}


export function getCustomization<T>(customization?: IContentPicker<ICustomization>, contentType?: CustomizationType): T {
    const result = customization?.contentItems.find(x => x.screenSize?.screen?.includes(getCurrentScreenSize()) && x.contentType === contentType) as T;
    return result;
}

export function getCompatibleLayout(layouts?: IContentPicker<ILayoutStyle>): ILayoutStyle {
    const width: number = store.getState().windowWidth;
    const { small, medium, large } = Config.get<IViewport>("viewport");
    let currentScreenSize: ScreenSize =
        width > large ? "xlarge" :
            width > medium && width <= large ? "large" :
                width > small && width <= medium ? "medium" : "small";
    return layouts?.contentItems.find(x => x.screenSize?.screen?.includes(currentScreenSize))
        || { wrap: true, columnCount: 1, itemLayouts: { contentItems: [{ colSpan: 1, rowSpan: 1 }] } };
}

export default WidgetContainer